"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Jednostavna upotreba",
  description: "Iskoristite prednosti web i mobilne softverske platforme prilagođene korisnicima i jednostavne za rukovanje bez potrebe za posebnim hardverom ili infrastrukturom.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_easy_operate.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_easy_operate.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_easy_operate.png-wvc-sizes",
    alt: "Ilustracija jednostavne upotrebe"
  }
}, {
  title: "Alat za obuku",
  description: "Uštedite vrijeme koristeći aplikaciju Mobileo kao alat za obuku vaših djelatnika i nadzornika, pružajući sve informacije potrebne za obavljanje njihovog posla.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_training_tool.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_training_tool.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_training_tool.png-wvc-sizes",
    alt: "Ilustracija alata za obuku"
  }
}, {
  title: "Bez papira",
  description: "Prijeđite s rada temeljenog na olovci i papiru na digitalnu platformu, smanjite otpad i istovremeno pomozite okolišu.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_paperless.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_paperless.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/differentiate_paperless.png-wvc-sizes",
    alt: "Ilustracija rada bez papira"
  }
}];
export default function DifferentiateCompany() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="differentiatecompany" className="bg-background py-16 md:py-24 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground"><span className="text-primary" data-ast-id="f:/src/pages/Features/sections/DifferentiateCompany.tsx|sig:p8yc2l" data-ast-start="2698" data-ast-end="2745" contenteditable="false" style={{}}>Istaknite</span> svoju tvrtku na tržištu</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-12">
          {features.map((feature, index) => <Card key={index} data-index={index} className="border-none bg-transparent flex flex-col items-center text-center">
              <CardHeader className="p-0 mb-6 w-full max-w-[280px] mx-auto">
                <img src={feature.image.src} data-wvc-srcset={feature.image.srcset} data-wvc-sizes={feature.image.sizes} alt={feature.image.alt} className="w-full h-auto object-contain" loading="lazy" />
              </CardHeader>
              <CardContent className="p-0 flex-grow">
                <CardTitle className="text-xl md:text-2xl font-bold font-default mb-4 text-foreground">
                  {feature.title}
                </CardTitle>
                <CardDescription className="text-base text-muted-foreground leading-relaxed">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>

        <div className="flex justify-center">
          <Link to="#">
            <Button size="lg" className="font-semibold px-8 rounded-lg">
              Saznajte više o prednostima
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}